import { SettingFormData } from '../../models'
import {
    SETTINGS_SAGA_GET_SETTINGS,
    SETTINGS_SAGA_SET_SETTINGS,
} from '../actionTypes'

export const getSettings = () => ({ type: SETTINGS_SAGA_GET_SETTINGS })
export const setSettings = (settings: SettingFormData[]) => ({
    type: SETTINGS_SAGA_SET_SETTINGS, settings,
})
